// note the "ls." prefix- it seems that Angular's abstraction prefixes this, so we do it manually
const ANGULAR_LOCAL_STORAGE_KEY = 'currentApiToken';
export const LOCAL_STORAGE_KEY = `ls.${ANGULAR_LOCAL_STORAGE_KEY}`;

// special indication to the other side of the app to attempt a guest login (api may disallow)
